import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function BathTub(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M13.616 5H13a1 1 0 100 2h3a1 1 0 100-2h-.294A1.727 1.727 0 0119 5.727V10H3a1 1 0 100 2h.016c-.01.059-.016.12-.016.182V15c0 1.636.786 3.088 2 4v2a1 1 0 102 0v-1.1c.323.066.658.1 1 .1h8c.343 0 .677-.034 1-.1V21a1 1 0 102 0v-2a4.993 4.993 0 002-4v-3a1 1 0 100-2V5.727A3.727 3.727 0 0013.616 5zm-8.632 7H19v3a3 3 0 01-3 3H8a3 3 0 01-3-3v-2.818c0-.062-.006-.123-.016-.182z",
    clipRule: "evenodd"
  }));
}

export default BathTub;